import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

const sanitize = html => {
  return { __html: DOMPurify.sanitize(html, { ADD_ATTR: ['target'] }) };
};

/**
 * SafeHtml renders a string of potentially unsanitized html safely using
 * DOMPurfiy.
 *
 * @param {string} html - the html to render safely (use instead of dangerouslySetInnerHTML)
 * @param {...*} props - other props (passed through)
 */
const SafeHtml = ({ html, ...props }) => {
  const dangerouslySetInnerHTML = useMemo(() => sanitize(html), [html]);

  if (html != null) {
    props = { ...props, dangerouslySetInnerHTML };
  }

  return <div {...props} />;
};

SafeHtml.propTypes = {
  html: PropTypes.string,
};

export default SafeHtml;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/safe_html.jsx